/**
 * Request ID utilities for end-to-end tracing
 */

export function generateRequestId(): string {
  return crypto.randomUUID()
}

interface AxiosError {
  response?: {
    headers?: Record<string, string>
  }
  config?: {
    headers?: Record<string, string>
  }
}

function isAxiosError(error: unknown): error is AxiosError {
  return (
    typeof error === "object" &&
    error !== null &&
    ("response" in error || "config" in error)
  )
}

export function extractRequestIdFromError(error: unknown): string | null {
  if (!isAxiosError(error)) {
    return null
  }

  if (error?.response?.headers?.["x-request-id"]) {
    return error.response.headers["x-request-id"]
  }

  if (error?.config?.headers?.["X-Request-Id"]) {
    return error.config.headers["X-Request-Id"]
  }

  return null
}
